import "./DrugTable.css"; // Make sure to create this CSS file
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";

export default function DrugTable({ drugData }) {
  return (
    <div className="table-container">
      <h2 className="table-heading">Batch Release Approval Inventory</h2>
      <table className="drug-table">
        <thead>
          <tr>
            <th>Drug Name</th>
            <th>Sequence Range</th>
            <th>Depot Name</th>
            <th>Lot Number</th>
            <th>Label Group</th>
            <th>Kit Quantity</th>
            <th>Performed By</th>
            <th>Protocol</th>
            <th>Approve</th>
            {/* <th>Reject</th> */}
          </tr>
        </thead>
        <tbody>
          {drugData.map((row, idx) => (
            <tr
              key={idx}
              className={row.isApproved ? "approved-row" : "rejected-row"}
            >
              <td>{row.drugName}</td>
              <td>{row.sequenceRange}</td>
              <td>{row.depotName}</td>
              <td>{row.lotNumber}</td>
              <td>{row.labelGroupName}</td>
              <td>{row.kitQuantity}</td>
              <td>{row.performedBy}</td>
              <td>{row.protocol}</td>
              <td>
                {row.isApproved ? (
                  <DoneIcon sx={{ color: "#337ab7" }} />
                ) : (
                  <ClearIcon sx={{ color: "black" }} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
